module.exports = __webpack_public_path__ + "img/hr-V-R-6-load-connect-shadow.d012ca98.png";